export const parkings = [
  {
    "id": "6314a618f47a0145a1e8a367",
    "name": "پارکینگ اربعین",
    "coordinates": [
      46.19849261,
      33.15840187
    ]
  },
  {
    "id": "6314a618f47a0145a1e8a368",
    "name": "پارکینگ برکت",
    "coordinates": [
      46.12857597,
      33.10213323
    ]
  }
]